import { Component, inject, Input } from "@angular/core";
import {
  FloorplanItemDetailsModal,
  ModalProductItem,
} from "@components/floorplan-item-attachments-modal/floorplan-item-details-modal.component";
import { FloorplanMonitoringItemDetailsModalComponent } from "@components/floorplan-monitoring-item-details-modal/floorplan-monitoring-item-details-modal.component";
import { MonitoringCategory } from "@domain/product/monitoring/monitoring-product.service";
import { PlaceholderProduct } from "@domain/project/floorplan/placeholder-product";
import { UserService } from "@domain/user/user.service";
import { BusinessScope } from "@lib/constants/business-scope";
import { LinkDirective } from "@odx/angular/components/link";
import { ModalService, ModalSize } from "@odx/angular/components/modal";
import { MonitoringProductItem } from "@project/monitoring-product-item";
import { createMonitoringGroupedSourceItem } from "@project/monitoring/grouped-parts/monitoring-grouped-parts-source-item.factory";
import { getMonitoringConfigurationSummaryTitle } from "@project/monitoring/grouped-parts/monitoring-grouped-parts.helper";
import { MonitoringGroupedPartSourceItem } from "@project/monitoring/grouped-parts/monitoring-grouped-parts.types";

@Component({
  selector: "app-floorplan-item-attachments-button",
  imports: [LinkDirective],
  templateUrl: "./floorplan-item-attachments-button.component.html",
  standalone: true,
})
export class FloorplanItemAttachmentsButtonComponent {
  @Input({ required: true }) productItems!: ModalProductItem[] | MonitoringProductItem[];
  @Input() attachments: ModalProductItem[] = [];
  @Input() customProducts: PlaceholderProduct[] = [];
  @Input() gasId?: string;
  @Input() monitoringCategory?: MonitoringCategory;
  @Input() monitoringItems?: MonitoringGroupedPartSourceItem[];
  @Input() monitoringTitle?: string;

  private readonly modalService = inject(ModalService);
  private businessScope!: BusinessScope;
  private userService = inject(UserService);

  constructor() {
    this.userService.businessScope$.subscribe((scope) => {
      this.businessScope = scope;
    });
  }

  protected showAttachments() {
    if (this.businessScope === BusinessScope.FGDS) {
      this.modalService
        .open(FloorplanItemDetailsModal, {
          id: "fgds-item-details-modal",
          size: ModalSize.LARGE,
          data: {
            productItems: this.productItems as ModalProductItem[],
            attachments: this.attachments,
            customProducts: this.customProducts,
            ...(this.gasId ? { gasId: this.gasId } : {}),
          },
        })
        .onClose$.subscribe();
    } else if (this.businessScope === BusinessScope.MONITORING) {
      const items = this.monitoringItems ?? this.mapMonitoringItems();
      this.modalService.open(FloorplanMonitoringItemDetailsModalComponent, {
        id: "monitoring-item-details-modal",
        size: ModalSize.LARGE,
        data: {
          items,
          category: this.monitoringCategory,
          title: this.monitoringTitle ?? this.resolveMonitoringTitle(),
        },
      });
    }
  }

  private mapMonitoringItems(): MonitoringGroupedPartSourceItem[] {
    const productItems = this.productItems as MonitoringProductItem[];
    return (productItems ?? []).map((item) => createMonitoringGroupedSourceItem(item, ""));
  }

  private resolveMonitoringTitle(): string {
    return getMonitoringConfigurationSummaryTitle(this.monitoringCategory ?? MonitoringCategory.PATIENT_MONITORS);
  }
}
